import {
  EDIT_PASSWORD_SUCCESS,
  EDIT_PASSWORD_FAIL,
  EDIT_PASSWORD_REQUEST
} from "../../constants/actions";
import { postData, uploadImage } from "../../../services/api";
import { ApiURLs } from "../../../constant/ApiUrls";
import { hideEditProfileModal } from "./editProfileModalDispatch";
import { updateUserInfo } from "./authDispatcher";
import localStorageServices from "../../../services/LocalStorage";
import { LocalStorageKeys } from "../../../constant/LocalStorageKeys";


export const editProfileRequest = (data, navigate) => {
  return async (dispatch) => {

    dispatch(editProfileReq());
    try {

      if (data.profile_image) {
        var uploadedImage = await uploadImage(
          ApiURLs.UPLOAD_IMAGE, "image",

          data.profile_image,
          "admin/profile-image"
        );
        console.log(`upload image function response ${JSON.stringify(uploadedImage)}`)
        data.profile_image = uploadedImage.data.file.path
      }
      var editProfileData = await postData(data, ApiURLs.EDIT_PROFILE);
      if (editProfileData.status === 1) {
        dispatch(editProfileSucess());
        if (data.profile_image) {

          data.image = data.profile_image;
        }
        dispatch(updateUserInfo(data));
        var getCurrentData = localStorageServices.getItem(LocalStorageKeys.userInfo);
        const newUserInfo = { ...getCurrentData, ...data };
        localStorageServices.setItem(LocalStorageKeys.userInfo, newUserInfo);

        dispatch(hideEditProfileModal())
      } else {
        dispatch(editProfileReqFail());
      }
    } catch (error) {
      dispatch(editProfileReqFail());

    }
  };
};

export const editProfileReq = () => {
  return {
    type: EDIT_PASSWORD_REQUEST,
  };
};

export const editProfileSucess = () => {
  return {
    type: EDIT_PASSWORD_SUCCESS,
  };
};

export const editProfileReqFail = (error) => {
  return {
    type: EDIT_PASSWORD_FAIL,
    payload: error,
  };
};
